import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import ko from "./locales/ko.json";

// 기본 언어 = 웹 브라우저 언어. ko* 면 한국어, 그 외 전부 영어.
// (저장된 사용자 설정은 없음 — 매 접속 시 브라우저 언어를 따름)
function detectLocale() {
  try {
    const lang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    return lang.startsWith("ko") ? "ko" : "en";
  } catch (e) {
    return "ko";
  }
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: "ko",
  messages: {
    en,
    ko,
  },
});

export default i18n;
